import { render, staticRenderFns } from "./SportCreateAndUpdateFormItems.vue?vue&type=template&id=7bb5a6ec&"
import script from "./SportCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./SportCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports